var map = {
	"./excel.png": "2af3",
	"./file.png": "7f46",
	"./image.png": "dfd2",
	"./pdf.png": "342d",
	"./ppt.png": "cd8a",
	"./video.png": "22cf",
	"./word.png": "d52a",
	"./zip.png": "f751"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55ee";